module.exports = __webpack_public_path__ + "img/Vie.716547f4.svg";